import HeaderFilter from '../../../components/HeaderFilter';
import UnitOfMeasureTable from './UnitOfMeasureTable';
import UnitOfMeasureForm from './UnitOfMeasureForm';

const UnitOfMeasurePage = () => {
  const api = '/product/uoms';
  const moduleCode = 'PRODUCTUOM';
  const moduleName = 'Unit of Measure';
  return (
    <>
      <div className={'page-wrapper'}>
        <HeaderFilter />
        <UnitOfMeasureTable
          api={api}
          moduleCode={moduleCode}
          moduleName={moduleName}
        />
        <UnitOfMeasureForm api={api} moduleName={moduleName} />
      </div>
    </>
  );
};

export default UnitOfMeasurePage;
